import { useNavigation } from "@react-navigation/native";
import background from "assets/images/backgroundRotated.png";
import theme from "assets/theme";
import React, { useContext, useState } from "react";
import {
  Button,
  Image,
  StyleSheet,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import AuthService from "services/Auth.service";
import { SCREEN_ADMIN_LOGIN } from "web/constants";
import { ToastContext } from "web/context/Toast.context";
import Overlay from "webComponentsFormElements/Overlay.component";
import LabelInput from "webComponentsFormElements/inputs/LabelInput.component";

const classes = StyleSheet.create({
  root: {
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  imageContainer: {
    width: "100%",
    alignItems: "center",
  },
  logoImage: {
    width: "100%",
    height: "250px",
  },
  bgImage: {
    position: "absolute",
    opacity: 0.9,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  card: {
    alignSelf: "flex-end",
    backgroundColor: "rgba(49, 120, 170, 1)",
    borderLeftColor: "rgb(110, 182, 234)",
    borderLeftWidth: 2,
    height: "100%",
    minWidth: "500px",
    width: "20%",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  headerText: {
    fontSize: 28,
    fontWeight: theme.font.weight.medium,
    color: theme.color.white,
  },
  titleText: {
    fontSize: 28,
    fontWeight: theme.font.weight.medium,
    color: theme.color.white,
  },
  inputContainer: {
    width: "65%",
    alignItems: "center",
    justifyContent: "center",
    height: "10%",
    gap: 16,
  },
  headerContainer: {
    marginBottom: 8,
    height: "100%",
    width: "80%",
    alignItems: "center",
  },
  buttonContainer: {
    paddingTop: 50,
    width: "100%",
  },
});

export default function Register() {
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { showToast } = useContext(ToastContext);
  const navigation = useNavigation();
  const width = useWindowDimensions().width;
  const handleRegisterPress = async () => {
    try {
      const res = await AuthService.registerUser(code, password);

      if (res?.message === "User Created") {
        showToast("Registration successful! You can now log in.", "success");
        navigation.navigate(SCREEN_ADMIN_LOGIN);
      } else {
        // email not found
        if (__DEV__) {
          console.error("This email does not exist in the database");
        }
        showToast("Invalid credentials were provided to the client.", "error");
      }
    } catch (err) {
      if (__DEV__) {
        console.error("Login Error: ", err);
      }
      showToast("Invalid credentials were provided to the client.", "error");
    }
  };

  const stateClasses = StyleSheet.create({
    card: {
      ...classes.card,
      ...(width <= 500
        ? {
            alignSelf: "center",
            width: "100%",
            minWidth: "auto",
          }
        : {
            alignSelf: "flex-end",
          }),
    },
  });

  return (
    <View style={classes.root}>
      <Image source={background} resizeMode="cover" style={classes.bgImage} />
      <View style={stateClasses.card}>
        <Overlay />
        <View style={classes.inputContainer}>
          <Text style={classes.titleText}>Business Continuity Plan</Text>
          <Text style={classes.headerText}>Admin Register</Text>
          <View style={classes.headerContainer} />
          <LabelInput
            variant="white"
            label="6-Digit Code"
            required
            value={code}
            onChangeText={setCode}
          />
          <LabelInput
            variant="white"
            required
            label="Password"
            isPassword
            value={password}
            onChangeText={setPassword}
          />

          <LabelInput
            variant="white"
            required
            label="Confirm Password"
            isPassword
            value={confirmPassword}
            onChangeText={setConfirmPassword}
          />

          <View style={classes.buttonContainer}>
            <Button
              title="Register"
              color={theme.color.primary}
              onPress={handleRegisterPress}
              disabled={
                code.length !== 6 ||
                password.length < 8 ||
                password !== confirmPassword
              }
            />
          </View>
        </View>
      </View>
    </View>
  );
}
